import { render, staticRenderFns } from "./WelfareList.vue?vue&type=template&id=6da213f3&scoped=true"
import script from "./WelfareList.vue?vue&type=script&lang=js"
export * from "./WelfareList.vue?vue&type=script&lang=js"
import style0 from "./WelfareList.vue?vue&type=style&index=0&id=6da213f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da213f3",
  null
  
)

export default component.exports